import LOADER from '@ott/utility-loader';
import * as T from './actionTypes';

export const initialState = {
  locations: [],
  selectedLocation: {},
  status: LOADER.initial(),
  queue: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case T.FETCH_LOCATIONS_START: {
      return {
        ...state,
        status: LOADER.begin(),
      };
    }

    case T.FETCH_LOCATIONS_SUCCESS: {
      return {
        ...state,
        status: LOADER.success(),
        locations: action.payload,
      };
    }

    case T.FETCH_LOCATIONS_FAIL: {
      return {
        ...state,
        status: LOADER.error(action.error),
      };
    }

    case T.SELECT_LOCATION: {
      return {
        ...state,
        selectedLocation: action.payload,
      };
    }

    case T.SET_QUEUE: {
      return {
        ...state,
        queue: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
